import { render, staticRenderFns } from "./v-year-month-picker.vue?vue&type=template&id=28398974&"
import script from "./v-year-month-picker.vue?vue&type=script&lang=js&"
export * from "./v-year-month-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports